// Flattens applied filter selections into CleverTap-friendly primitives:
// one comma-joined string per non-empty category, e.g. filter_propertyType: "Residential".
export function buildFilterEventProps(selected) {
  const props = { filters_count: 0 };
  for (const [category, values] of Object.entries(selected || {})) {
    if (!values?.length) continue;
    props[`filter_${category}`] = values.join(", ");
    props.filters_count += values.length;
  }
  return props;
}
